export default "__VITE_ASSET__CcER3POj__"